import React, { useState } from "react";
// import { IArticle } from "../order/orderDetail";
import { Link } from "react-router-dom";
import Collapse from "../Collapse/Collapse";
import { BsCalendar, BsCaretDown, BsCaretUp, BsHash } from "react-icons/bs";
import SalesArticleDetail from "./salesArticleDetail";
import classNames from "classnames";
import { useSelectedArticleStore } from "../../store/store";
import { Article } from "../../api/order/generated/src";
import { useTranslation } from "react-i18next";

interface ISalesArticleItemProps {
    article:Article;

    onSelect: (id:string) => void;
    selected: boolean;
}

const SalesArticleItem = (props:ISalesArticleItemProps) => {
    const { article, selected, onSelect } = props;

    const { t } = useTranslation();

    const selectedArticle = useSelectedArticleStore(state => state.article);
    

    const articleSelected = article.id === selectedArticle.id;

    // const [showInfos, setShowInfos] = useState<boolean>(false);

    // const showInfos = selected;
    const showInfos = articleSelected;

    const collapseInfos = true;


    const isComplete = article.quantity != null && article.quantity === article.quantityBooked;
    const isPartial = article.quantity != null && (article.quantityBooked ?? 0) > 0 && article.quantity > (article.quantityBooked ?? 0)


    const getStatusColor = (status: string) => {
        switch (status) {
        case 'complete': return 'bg-green-50 text-green-800 border-green-200';
        case 'partial': return 'bg-blue-50 text-blue-800 border-blue-200';
        case 'pending': return 'bg-gray-50 text-gray-800 border-gray-200';
        default: return 'bg-gray-50 text-gray-800 border-gray-200';
        }
    };


    // let type = "";

    // if(article.batchItems != null && article.batchItems.length > 0){
    //     type = "batch";
    // }
    // else if(article.serialItems != null && article.serialItems.length > 0){
    //     type = "serial";
    // }

    const type = article.type;

    return (
        <>
            <div 
                key={article.id} 
                className={classNames(`bg-white rounded-lg border p-4 ${getStatusColor(isComplete ? "complete" : isPartial ? "partial" : "pending")}`,
                    // {"selected-article border border-[green]": articleSelected}
                    {"ring-2 ring-blue-500 border-blue-300 bg-blue-50": articleSelected},
                    {"hover:border-gray-300 hover:shadow-sm": !articleSelected}
                )}

                onClick={() => {
                    onSelect(article.id ?? "");
                }}
            >
                <div className="flex items-start justify-between">
                    <div className="flex-1 min-w-0">
                        <div className="flex items-center space-x-2 mb-1">
                            <h3 className="font-medium text-gray-900">{article.externalId}</h3>
                            {type === 'SERIAL' && (
                                <span className="px-2 py-1 text-xs bg-gray-100 text-gray-700 rounded-full flex items-center space-x-1">
                                    <BsHash className="w-3 h-3" />
                                    <span>{t("common:serial")}</span>
                                </span>
                            )}
                            {type === 'BATCH' && (
                                <span className="px-2 py-1 text-xs bg-gray-100 text-gray-700 rounded-full flex items-center space-x-1">
                                    <BsCalendar className="w-3 h-3" />
                                    <span>{t("common:batch")}</span>
                                </span>
                            )}
                            <span className={`px-2 py-1 text-xs rounded-full font-medium ${
                                isComplete ? 'bg-green-100 text-green-700' :
                                    isPartial ? 'bg-blue-100 text-blue-700' :
                                        'bg-gray-100 text-gray-600'
                            }`}>
                                {article.quantityBooked}/{article.quantity}
                            </span>
                        </div>
                        <p className="text-sm text-gray-600 mb-3">{article.title}</p>
                        
                        {/* Progress bar for individual item */}
                        <div className="w-full bg-gray-200 rounded-full h-1.5 mb-3">
                            <div 
                                className={`h-1.5 rounded-full transition-all duration-300 ${
                                    isComplete ? 'bg-green-500' :
                                        isPartial ? 'bg-blue-500' :
                                            'bg-gray-300'
                                }`}
                                style={{ width: `${(article.quantity ?? 0) > 0 && Math.min(((article.quantityBooked ?? 0) / (article.quantity ?? 0)) * 100, 100)}%` }}
                            ></div>
                        </div>
                    </div>



                
                </div>

                <Collapse open={showInfos || !collapseInfos}>
                    <div className="w-full">
                        <div 
                            // className="pt-4"
                        >
                            <SalesArticleDetail 
                                // articleId={article.id}
                                article={article}
                            />  
                        </div>
                    </div>
                </Collapse>

                
            </div>


            {/* <div className="">
                

                <div 
                    className={classNames(
                        "gap-4 grid w-full rounded-lg bg-white shadow-lg p-4 mb-4", 
                        {"selected-article border border-[green]": articleSelected}
                    )}

                    onClick={() => {
                        onSelect(article.id ?? "");
                    }}
                >
                    <div 
                        // className="flex flex-col gap-4 lg:grid lg:grid-cols-[5fr_1fr_1fr]  sm:grid-flow-col"
                        className="flex flex-row gap-4"
                        // onClick={() => {
                        //     setShowInfos(!showInfos);
                        // }}
                    >
                        <div className="grow">
                            <div>
                                {article.externalId}
                            </div>
                            <div>
                                {article.title}
                            </div>
                        </div>
                        
                        <div className={
                            classNames("flex flex-row gap-2 p-2",
                                {" bg-white": !(isComplete || isPartial)},
                                {" bg-[lightgreen]": isComplete},
                                {" bg-[#ffdb84]": isPartial}
                            )

                        }>
                            <span>{article.quantityBooked} / {article.quantity}</span>
                        </div>
                        <div>
                            <div className="w-full flex justify-end">
                                {showInfos 
                                    ?
                                        <BsCaretUp 
                                            // onClick={() => {
                                            //     setShowInfos(false);
                                            // }}
                                            className="self-end"
                                        />
                                    :
                                        <BsCaretDown 
                                            // onClick={() => {
                                            //     setShowInfos(true);
                                            // }}
                                            className="self-end"
                                        />
                                }
                            </div>
                        </div>
                    </div>

                    <Collapse open={showInfos || !collapseInfos}>
                        <div className="w-full">
                            <div className="pt-4">
                                <SalesArticleDetail 
                                    // articleId={article.id}
                                    article={article}
                                />  
                            </div>
                        </div>
                    </Collapse>
                </div>




            </div> */}


            {/* <Link to={`/article/${article.id}`}>
                <div className="gap-4 grid w-full rounded-lg bg-white shadow-lg p-4 mb-4">
                    <div className="flex flex-col gap-4 lg:grid lg:grid-cols-[2fr_2fr_1fr_2fr]  sm:grid-flow-col">
                        {article.title}

                        <div>
                            <span>{article.booked} / {article.ordered}</span>
                        </div>
                    </div>
                </div>
            </Link> */}
        </>
    )
};

export default SalesArticleItem;
